import SelectInput from './SelectInput';
import PasswordInput from './PasswordInput';

const labelExculdes = ['checkbox', 'radio'];

const FormInput = ({
  id,
  label = null,
  error = null,
  placeholder = '',
  formFieldType,
  isRequired,
  register,
  isDisabled = false,
  autoComplete,
  ...attrs
}) => (
  <div className="form-container__form__form-input">
    {!!label && !labelExculdes.includes(formFieldType) && (
      <label>
        <span>{label}</span>
        {!!isRequired && <span>*</span>}
      </label>
    )}

    {renderInput({
      id,
      label,
      placeholder,
      formFieldType,
      isRequired,
      register,
      error,
      autoComplete,
      ...attrs
    })}
    {error && (
      <div className="form-container__form__form-input__error-message">
        <i className="material-icons">warning</i>
        <span>{error.message}</span>
      </div>
    )}
  </div>
);

const renderInput = ({ ...props }) => {
  const {
    formFieldType: type,
    label,
    value,
    id,
    register,
    options,
    error,
    disabled,
    isRequired,
    placeholder,
    isDisabled,
    autoComplete
  } = props;

  const inputClassName = error ? 'error-field' : '';

  switch (type) {
    case 'select':
      return (
        <SelectInput
          id={id}
          label={label}
          selected={value}
          register={register}
          options={options}
          selectDisabled={disabled}
          showDefaultOption={false}
          required={isRequired}
          disabled={isDisabled}
          value={value}
          placeholder={placeholder}
          classNames={inputClassName}
        />
      );

    case 'checkbox':
      return (
        <div className="checkbox-input">
          <div className="checkbox-wrapper">
            <div className="form-field form-field--checkbox" role="button">
              <input
                type="checkbox"
                id={id}
                {...register(id)}
                className="form-checkbox"
                disabled={isDisabled}
              />
              <label>
                <span>{label}</span>
              </label>
            </div>
          </div>
        </div>
      );

    case 'radio':
      return (
        <div className="form-field form-field--radio" disabled={isDisabled}>
          <input id={id} type="radio" {...register(id)} className={inputClassName} />
          <span>{label}</span>
        </div>
      );
    case 'password':
      return (
        <PasswordInput
          id={id}
          placeholder={placeholder}
          className={inputClassName}
          autoComplete={autoComplete}
          register={register}
        />
      );
    default:
      return (
        <input
          id={id}
          type={type ?? 'text'}
          placeholder={placeholder}
          {...register(id)}
          className={inputClassName}
        />
      );
  }
};

export default FormInput;
